import { BASKET_TYPES, selectBasketList } from 'containers/OrderDetails/basketSlice'
import Summary from 'containers/OrderDetails/Summary/SimplifiedSummary'
import { getCompaniesFields, selectFieldsStatus } from '../formSlice'
import { COMPANY_EDIT_FIELDS, getMissingInputs } from '../Contract/fields'
import { selectIsLoggedIn } from '../../Login/loginSlice'
import { LOCATION_STATES, STATUS } from 'utils/constants'
import useProceedToSummary from './useProceedToSummary'
import CustomerDataPopup from './CustomerDataPopup'
import usePopupState from 'hooks/usePopupState'
import useCartCustomer from './useCartCustomer'
import { useSelector, useDispatch } from 'react-redux'
import useOrderRedirect from 'hooks/useOrderRedirect'
import { useEffect, useRef, useState } from 'react'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { companies, userInfo } from 'rest/urls'
import { useHistory } from 'react-router-dom'
import { GET } from 'rest/request'
import Companies from './Companies'
import NewMagBtn from './NewBtn'
import User from './User'
import '../style.scss'
import './style.scss'

const Billing = ({ isDesktop }) => {
  const list = useSelector(selectBasketList)
  const isLogin = useSelector(selectIsLoggedIn)
  const fieldsStatus = useSelector(selectFieldsStatus)
  const [companyIdx, setCompanyIdx] = useState(undefined)
  const [invoice, setInvoice] = useState(undefined)
  const [data, setData] = useState({
    company: [],
    user: {},
  })

  const { push } = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { customer, customerValidation, requiredInputs, isPrivateIncomplete, waitForSync } = useCartCustomer(isLogin)
  const { proceed, isChecking } = useProceedToSummary(waitForSync)
  const { popup, openPopup } = usePopupState()

  const menuRef = useRef(null)
  // podmiot, dla którego modal z brakami już się sam otworzył — po zamknięciu nie wraca, dopóki wybór się nie zmieni
  const promptedRef = useRef(null)

  const selectedCompany = invoice && companyIdx !== undefined ? data.company?.[companyIdx] : undefined
  // liczymy tylko braki, które da się poprawić w modalu; firmy innego właściciela (canEdit: false) nie edytujemy —
  // pozostałe przypadki wyłapie walidacja koszyka przy „Dalej” (/contract)
  const isCompanyIncomplete = !!selectedCompany && selectedCompany.canEdit !== false &&
    getMissingInputs(selectedCompany, requiredInputs?.company).some(f => COMPANY_EDIT_FIELDS.includes(f))

  useOrderRedirect()

  useEffect(() => {
    if (isLogin && fieldsStatus !== STATUS.succeed) dispatch(getCompaniesFields())
  }, [dispatch, fieldsStatus, isLogin])

  useEffect(() => {
    if (isLogin && fieldsStatus === STATUS.succeed) {
      getData().then(() => getData(true))
    }
  }, [fieldsStatus, isLogin])


  // braki w danych do umowy: modal od razu po wybraniu osoby prywatnej / firmy (lub gdy dane dojdą później)
  const selectionKey = invoice === false
    ? 'private'
    : selectedCompany ? `company-${selectedCompany.id ?? companyIdx}` : null
  const isSelectionIncomplete = invoice === false ? isPrivateIncomplete : isCompanyIncomplete

  useEffect(() => {
    if (!selectionKey) {
      promptedRef.current = null
      return
    }
    if (promptedRef.current === selectionKey || !isSelectionIncomplete) return
    promptedRef.current = selectionKey
    openPopup(invoice === false ? 'userData' : 'companyData')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionKey, isSelectionIncomplete])

  // wynajem prywatny: przy brakach w danych do umowy od razu pokazujemy formularz zamiast przechodzić dalej
  const nextPrivate = () => {
    if (isPrivateIncomplete) openPopup('userData')
    else proceed(false)
  }

  const selectData = (_invoice) => {
    if (!_invoice && companyIdx === undefined) return
    if (!_invoice && isCompanyIncomplete) return openPopup('companyData')
    proceed(_invoice || selectedCompany)
  }

  const getData = async (user = false) => {
    try {
      const response = await GET(user ? userInfo : companies)
      if (response.data) {
        setData(d => {
          return {
            ...d,
            [user ? 'user' : 'company']: response.data
          }
        })
      }

    } catch (err) {
      console.warn('Fetch: failed')
    }
  }

  return (
    <>
      {popup === 'companyData' && selectedCompany && <CustomerDataPopup
        company={selectedCompany}
        customerValidation={customerValidation}
        onSaved={() => getData()}
        waitForSync={waitForSync}
      />}
      <div className={`billing ${isDesktop ? '--desktop' : ''}`}>
        <div className='title'>
          <div>{t('form.dataCompletion')}</div>
          <div>{t('form.contractData')}</div>
        </div>

        <div
          ref={menuRef}
          className='billing__main main center'>
          <div className='billing__menu'>
            <div
              className={`menu__item group ${invoice ? '--selected' : ''}`}
              onClick={() => setInvoice(true)}>
              <div className='item__desc'>
                <div>{t('form.invoiceFor')}</div>
                <div>{t('form.company')}</div>
              </div>

              <div className='checkCircle'><i className='icon icon--check'></i></div>
            </div>

            <div
              className={`menu__item group ${invoice === false ? '--selected' : ''}`}
              onClick={() => setInvoice(false)}>
              <div className='item__desc'>
                <div>{t('form.invoiceFor')}</div>
                <div>{t('form.privateIndividual')}</div>
              </div>

              <div className='checkCircle'><i className='icon icon--check'></i></div>
            </div>
          </div>

          {invoice === undefined
            ? isDesktop
              ? null
              : <div className='billing__info'>
                <div className='orderTitle'>
                  <span>{t('basic.justMoment')}</span>
                  <span>{t('basic.doYouNeedMoreSpace')}</span>
                </div>
                <NewMagBtn />
              </div>
            : invoice
              ? <>
                <div className='--element__title'>{t('form.selectCompany')}</div>
                <Companies
                  menuRef={menuRef}
                  data={data?.company}
                  isDesktop={isDesktop}
                  companyIdx={companyIdx}
                  setCompanyIdx={setCompanyIdx}
                  selectData={selectData}
                  isChecking={isChecking}
                  requiredInputs={requiredInputs}
                  getData={getData} />
              </>
              : <User
                user={data.user}
                isDesktop={isDesktop}
                customer={customer}
                customerValidation={customerValidation}
                isIncomplete={isPrivateIncomplete}
                onSaved={() => getData(true)}
                waitForSync={waitForSync}
                next={nextPrivate}
                isChecking={isChecking}
              />}
        </div>
      </div>

      {isDesktop && <div className='orderInfo__aside'>
        <Summary />
        <div className='orderInfo__buttons'>
          <ArrowBtn
            enlarged
            text={t('basic.next')}
            isLoading={isChecking}
            disabled={invoice === undefined || (invoice && companyIdx === undefined)}
            action={() => {
              if (invoice) {
                selectData()
              } else {
                nextPrivate()
              }
            }} />
          <BackBtn
            text={t('form.addAnotherRental')}
            action={() => {
              if (list?.some(l => l.type === BASKET_TYPES.rent)) {
                push(window.location.pathname, LOCATION_STATES.popup('newMag'))
              } else {
                push('/shop')
              }
            }}
          />
        </div>
      </div>}
    </>
  )
}

export default Billing